<template>
    <div>
        <el-row>
            <el-col :span="24" style="text-align: left;"><el-button type="primary" size="small" round
                    @click="openDialog(null)">添加</el-button></el-col>
        </el-row>
        <el-row>
            <el-col>
                <div style="display: grid;place-items: center;background-color: #1D1D1B;">
                    <div style="text-align: left;width: 1320px;">
                        <div style="font-size: 30px;font-weight: bold;margin-top: 40px;">{{currentRow.firstTitle}}</div>
                        <!-- <div style="width: 100%;text-align: center;color: #FCB42E;font-size: 18px;font-weight: bold;margin-top: 80px;">{{currentRow.secondTitle}}</div>
                        <div style="width: 100%;text-align: right;color: #949494;font-size: 13px;margin-top: 15px;">{{currentRow.thirdTitle}}</div>
                        <div style="height: 4px;border: 1px solid;background-color: white;margin-top: 5px;"></div> -->
                        <div v-html="currentRow.content" class="preview" style="margin-top: 80px;"></div>
                    </div>
                </div>


            </el-col>
        </el-row>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="60%">
            <el-form :model="currentRow">
                <el-form-item label="标题" :label-width="formLabelWidth">
                    <el-input placeholder="请输入标题" v-model="currentRow.firstTitle"
                        style="display: inline;margin-left: 5px; " clearable required>
                    </el-input>
                </el-form-item>
                <!-- <el-form-item label="副标题" :label-width="formLabelWidth">
                    <el-input placeholder="请输入副标题" v-model="currentRow.secondTitle"
                        style="display: inline;margin-left: 5px; " clearable required>
                    </el-input>
                </el-form-item>
                <el-form-item label="标题注释" :label-width="formLabelWidth">
                    <el-input placeholder="请输入标题注释" v-model="currentRow.thirdTitle"
                        style="display: inline;margin-left: 5px; " clearable required>
                    </el-input>
                </el-form-item> -->
                <el-form-item label="招聘内容" :label-width="formLabelWidth">
                    <!-- <vue-editor v-model="currentRow.content" :options="editorOptions" ></vue-editor> -->
                    <ckeditor v-model="currentRow.content" :config="editorConfig" ></ckeditor>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveInfo">确 定</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>

</template>
<script>
    import { submitRecruitInfo, getRecruitData } from "@/api/rbac/about";
    export default {
        data() {
            return {
                dialogVisible: false,
                editorConfig: {
                    extraPlugins: 'font,colorbutton,justify', // 添加字体和颜色插件
                    toolbar: [
                        { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'] },
                        { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
                        { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                        { name: 'colors', items: ['TextColor', 'BGColor'] },
                        {name:'align',items:['JustifyLeft','JustifyCenter','JustifyRight',]},
                         { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 视频功能
                        { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 添加图片按钮
                        { name: 'links', items: ['Link', 'Unlink'] },
                        ['Source'],
                    ],
                    font_names: 'Arial/Arial, Helvetica, sans-serif;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif',
                    fontSize_sizes: '9/9px;11/11px;13/13px;16/16px;18/18px;21/21px;24/24px;28/28px;32/32px',
                    language: 'zh-cn',
                    height:'400px',
                },
                currentRow: { id: 0, firstTitle: '', secondTitle: '', thirdTitle: '', content: '', remark: '' },
                formLabelWidth: '120px',
                isFirstOpen: true,
            }

        },

        created() {
            this.loadDataList();
        },
        methods: {
            async loadDataList() {
                try {
                    getRecruitData().then(res => {
                        if (res.data.length == 0) {
                            this.currentRow = { id: 0, firstTitle: '', secondTitle: '', thirdTitle: '', content: '', remark: '' }
                        }
                        else {
                            this.currentRow = res.data[0]
                        }
                    })
                } catch (error) {
                    console.error('获取失败:', error);
                }
            },
            openDialog() {
                this.dialogVisible = true
                if (this.isFirstOpen) {
                    this.checkInterval = setInterval(() => {
                        const dynamicDivs = document.querySelectorAll('.cke_notifications_area');
                        if (dynamicDivs.length > 0) {
                            dynamicDivs.forEach((div) => {
                                div.style.display = 'none'
                            });
                            clearInterval(this.checkInterval); // 停止轮询
                            this.isFirstOpen = false;
                            // 可以在这里执行加载后的操作
                            // 如果只需要检查一次，可以调用 clearInterval(this.checkInterval);
                        }
                    }, 100); // 每 500ms 检查一次
                }
            },
            //保存
            saveInfo() {
                if (!String(this.currentRow.firstTitle).trim()) {
                    return alert("主标题为空")
                }
                // else if (!String(this.currentRow.secondTitle).trim()) {
                //     return alert("副标题为空")
                // }
                // else if (!String(this.currentRow.thirdTitle).trim()) {
                //     return alert("标题注释为空")
                // }
                else if (!String(this.currentRow.content).trim()) {
                    return alert("招聘内容为空")
                }
                else {
                    try {
                        // 使用正则表达式去除 HTML 标签
                        // this.popData.remark = this.popData.remark.replace(/<\/?[^>]+(>|$)/g, "");

                        submitRecruitInfo(this.currentRow).then(res => {

                            if (res.data.success) {

                                this.loadDataList("");

                                this.dialogVisible = false;
                            }
                        })
                    } catch (error) {
                        console.error('保存失败:', error);
                    }
                }

            },
        },
    }
</script>